// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	// TODO: write your page related code here...
	// $w("#horizontalMenu2 ul").style.padding = "100px 100px 100px 100px";


});

import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
function open_Lightbox(){
let query = wixLocation.query;
var goto = query.name;
wixWindow.openLightbox(goto);
}
$w.onReady(function () {
open_Lightbox();
});



export function columnStrip15_viewportLeave(event) {
	// Add your code for this event here: 
	$w("#columnStrip15").expand("FadeIn");
}
